
import { NewsItem } from "@/components/news/NewsCard";

export const newsItems: NewsItem[] = [
  {
    id: 1,
    title: "Publication de l'étude sur l'impact du changement climatique sur les forêts méditerranéennes",
    type: "news",
    date: "2023-09-28",
    excerpt: "Cette étude révolutionnaire met en lumière les effets spécifiques du changement climatique sur les forêts méditerranéennes et propose des stratégies d'adaptation.",
    tags: ["Publication", "Changement climatique"],
    image: "https://images.unsplash.com/photo-1502082553048-f009c37129b9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
    slug: "impact-changement-climatique-forets-mediterraneennes"
  },
  {
    id: 2,
    title: "Conférence internationale sur les forêts méditerranéennes",
    type: "events",
    date: "2023-10-15",
    location: "Montpellier, France",
    excerpt: "Une conférence réunissant experts et chercheurs pour discuter des défis spécifiques aux forêts méditerranéennes face au changement climatique.",
    tags: ["Conférence", "Méditerranée"],
    image: "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
    slug: "conference-internationale-forets-mediterraneennes"
  },
  {
    id: 3,
    title: "Nouveau partenariat avec l'Université de Barcelone",
    type: "news",
    date: "2023-09-05",
    excerpt: "GIP Ecofor annonce un nouveau partenariat avec l'Université de Barcelone pour étudier la résilience des écosystèmes forestiers méditerranéens.",
    tags: ["Partenariat", "Recherche"],
    image: "https://images.unsplash.com/photo-1541829070764-84a7d30dd3f3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1469&q=80",
    slug: "partenariat-universite-barcelone"
  },
  {
    id: 4,
    title: "Atelier doctoral sur la biodiversité forestière",
    type: "events",
    date: "2023-11-10",
    location: "Paris, France",
    excerpt: "Un atelier destiné aux doctorants travaillant sur les questions de biodiversité dans les forêts tempérées européennes.",
    tags: ["Formation", "Biodiversité"],
    image: "https://images.unsplash.com/photo-1503785640985-f62e3aeee448?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1474&q=80",
    slug: "atelier-doctoral-biodiversite-forestiere"
  },
  {
    id: 5,
    title: "Lancement du nouveau projet 'Forestt' sur l'adaptation des forêts au changement climatique",
    type: "news",
    date: "2023-08-20",
    excerpt: "GIP Ecofor lance un nouveau projet de recherche sur l'adaptation des forêts au changement climatique, en collaboration avec plusieurs partenaires européens.",
    tags: ["Projet", "Adaptation"],
    image: "https://images.unsplash.com/photo-1473448912268-2022ce9509d8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
    slug: "projet-forestt-adaptation-forets"
  },
  {
    id: 6,
    title: "Séminaire sur la gestion durable des forêts tropicales",
    type: "events",
    date: "2023-12-05",
    location: "Visioconférence",
    excerpt: "Un séminaire en ligne sur les pratiques de gestion durable dans les forêts tropicales, avec des intervenants internationaux de renom.",
    tags: ["Webinaire", "Gestion durable"],
    image: "https://images.unsplash.com/photo-1542273917363-3b1817f69a2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1474&q=80",
    slug: "seminaire-gestion-durable-forets-tropicales"
  },
  {
    id: 7,
    title: "Publication du rapport annuel sur l'état des forêts en Europe",
    type: "news",
    date: "2023-07-15",
    excerpt: "Le rapport annuel présente un état des lieux complet des forêts européennes, incluant des données sur la santé des écosystèmes, la biodiversité et les menaces émergentes.",
    tags: ["Rapport", "Monitoring"],
    image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1374&q=80",
    slug: "rapport-annuel-etat-forets-europe"
  },
  {
    id: 8,
    title: "Forum des jeunes chercheurs en sciences forestières",
    type: "events",
    date: "2024-01-22",
    location: "Lyon, France",
    excerpt: "Un forum dédié aux jeunes chercheurs pour présenter leurs travaux et échanger sur les défis de la recherche forestière contemporaine.",
    tags: ["Formation", "Réseau"],
    image: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
    slug: "forum-jeunes-chercheurs-sciences-forestieres"
  },
  {
    id: 9,
    title: "Nouvelle méthodologie pour l'évaluation de la santé des sols forestiers",
    type: "news",
    date: "2023-06-30",
    excerpt: "Des chercheurs du projet FORESTT-HUB ont développé une nouvelle méthodologie pour évaluer plus précisément la santé des sols forestiers et leur capacité de stockage du carbone.",
    tags: ["Innovation", "Sols"],
    image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1632&q=80",
    slug: "methodologie-evaluation-sante-sols-forestiers"
  },
  {
    id: 10,
    title: "Colloque sur les politiques forestières européennes",
    type: "events",
    date: "2024-03-05",
    location: "Bruxelles, Belgique",
    excerpt: "Un colloque réunissant décideurs politiques, chercheurs et acteurs de terrain pour discuter de l'évolution des politiques forestières en Europe.",
    tags: ["Politique", "Europe"],
    image: "https://images.unsplash.com/photo-1621416894569-0f39ed31d247?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1429&q=80",
    slug: "colloque-politiques-forestieres-europeennes"
  }
];
